import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TComponent } from 'utils/types/component';

import { PAYMENT_INVOICE_SCHEDULE_TYPE } from 'models/Invoice/Payment';

export const PeriodicitySelect: TComponent = () => {
    const { t } = useTranslation();

    return (
        <Form.Item label={t('common.form.periodicity')} name='scheduleType'>
            <Select placeholder={t('common.form.choosePeriodicity')}>
                <Select.Option value={PAYMENT_INVOICE_SCHEDULE_TYPE.DAILY}>
                    {t('invoices.payment.exportSettings.schedulingType.daily')}
                </Select.Option>
                <Select.Option value={PAYMENT_INVOICE_SCHEDULE_TYPE.WEEKLY}>
                    {t('invoices.payment.exportSettings.schedulingType.weekly')}
                </Select.Option>
                <Select.Option value={PAYMENT_INVOICE_SCHEDULE_TYPE.EVEN_WEEKS}>
                    {t(
                        'invoices.payment.exportSettings.schedulingType.evenWeeks',
                    )}
                </Select.Option>
                <Select.Option value={PAYMENT_INVOICE_SCHEDULE_TYPE.ODD_WEEKS}>
                    {t(
                        'invoices.payment.exportSettings.schedulingType.oddWeeks',
                    )}
                </Select.Option>
                <Select.Option value={PAYMENT_INVOICE_SCHEDULE_TYPE.MONTHLY}>
                    {t(
                        'invoices.payment.exportSettings.schedulingType.monthly',
                    )}
                </Select.Option>
            </Select>
        </Form.Item>
    );
};
